import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserRemoteControllerService } from 'core/api';
import { subjectFromObs } from 'core/rx-js';
import { catchError, distinctUntilChanged, filter, map, of, switchMap, take } from 'rxjs';
import { designerPaths } from '../designer.paths';
import { JwtService } from './jwt.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  readonly jwtSubject = this._jwtService.jwtSubject;
  readonly jwtExpiredSubject = this._jwtService.jwtExpiredSubject

  readonly jwtDecodedSubject = this._jwtService.jwtDecodedSubject;




  readonly userSubject = subjectFromObs({
    observable: this.jwtDecodedSubject.pipe(
      filter(Boolean),
      distinctUntilChanged((prev, next) => {
        return prev.sub === next.sub
      }),
      filter((decoded) => decoded.exp * 1000 > new Date().getTime()),
      switchMap(() => this._userRemoteControllerService.getCurrentUser().pipe(take(1), catchError(() => of(null)))),
    ),
    initialValue: null
  })

  readonly isAdminObs = this.jwtDecodedSubject.pipe(
    filter(Boolean),
    map((decodedJwt) => decodedJwt.roles?.includes('ROLE_administrator'))
  )

  readonly isCreatorObs = this.jwtDecodedSubject.pipe(
    filter(Boolean),
    map((decodedJwt) => decodedJwt.roles?.includes('ROLE_process_creator'))
  )

  get isAdmin() {
    return this.jwtDecodedSubject.value?.roles?.includes('ROLE_administrator')
  }

  get isCreator() {
    return this.jwtDecodedSubject.value?.roles?.includes('ROLE_process_creator')
  }


  constructor(
    private readonly _jwtService: JwtService,
    private readonly _userRemoteControllerService: UserRemoteControllerService,
    private readonly _router: Router
  ) { }

  goToUserSettings() {
    this._router.navigate([designerPaths.userManagement, this.userSubject.value?.id])
  }
}
